import styles from './index.module.scss'
import React from 'react';

// este componente de momento solo funciona para la lista de compras
class DropDown extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isOptionsOpen: false, selectedOption: null, marca: "cupra" }
  }

  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     const closeFiltro = (e) => {
  //       if (!filtroRef.current.contains(e.target)) { setIsOptionsOpen(false) }
  //     }
  //     window.addEventListener('mouseup', closeFiltro)
  //     return () => window.removeEventListener('mouseup', closeFiltro)
  //   }
  // }, [isOptionsOpen])

  // useEffect(() => {
  //   if (menu.length > 0 && typeof inputField?.value === 'object') {
  //     const index = menu.findIndex((element) => element.id === inputField?.value?.id)
  //     if (index >= 0) setSelectedOption(index)
  //   } else {
  //     setSelectedOption(null)
  //   }
  // }, [inputField, menu])

  componentDidUpdate() {
    if (this.props.menu.length > 0 && typeof this.props.inputField?.value === 'object') {
      const index = this.props.menu.findIndex((element) => element.id === this.props.inputField?.value?.id)
      if (index >= 0)
        this.setState({selectedOption : index})
    } 
    // else {
    //   this.setState({selectedOption : null})
    // }
  }

  toggleOptions = () => {
    this.setState({isOptionsOpen : !this.state.isOptionsOpen})
  }

  handleKeyDown = (e, index, option) => {
    switch (e.key) {
      case ' ':
      case 'SpaceBar':
      case 'Enter':
        e.preventDefault()
        this.onclickOptionSelected(index, option)
        break
      default:
        break
    }
  }

  onclickOptionSelected = (index, option) => {
    this.setState({isOptionsOpen : false, selectedOption: index})

    if (this.props.handleOptionSelected)
      this.props.handleOptionSelected(option, index)

    if (this.props.inputField?.onChange)
      this.props.inputField.onChange(option, index)
  }

  showSelectedOption = () => {
    if (this.props.inputField?.value) {
      return this.props.inputField.value.value.length > 52 ? this.props.inputField.value.value.substring(0, 52) + '...' : this.props.inputField.value.value
    } else if (this.state.selectedOption !== null && this.props.menu.length > 0) {
      return this.props.menu[this.state.selectedOption].modelo.length > 52 ? this.props.menu[this.state.selectedOption].modelo.substring(0, 52) + '...' : this.props.menu[this.state.selectedOption].modelo
    } else {
      return this.props.required ? this.props.title + '*' : this.props.title
    }
  }

  render() {
    return (
      <div className={styles[this.state.marca]} ref={this.state.filtroRef}>

        <div className={styles.containerMenu}>
          <button
            type="button"
            aria-haspopup="listbox"
            aria-expanded={this.state.isOptionsOpen}
            className={`${this.state.isOptionsOpen ? styles.expanded : ''} ${this.props.errors?.[this.inputField?.name] ? styles.error : ''}`}
            onClick={this.toggleOptions}>
            <div className={`${styles.content}`}>{this.showSelectedOption()}</div>
          </button>

          <ul
            className={`${styles.options} ${this.state.isOptionsOpen ? styles.show : ''}`}
            role='listbox'
            tabIndex={-1}>
            {
              this.props.menu.length === 1 && this.props.menu[0]?.id === 0
                ? this.props.menu.map((option, index) => (
                  <li
                    className={`${styles.optionElementList}`}
                    id={option.id}
                    role='option'
                    aria-selected={false}
                    tabIndex={0}
                    key={index}>
                    <p>{option.value}</p>
                  </li>
                ))
                : this.props.menu.map((option, index) => (
                  <li
                    className={`${styles.optionElementList} ${this.state.selectedOption === index ? styles.selectedOption : ''}`}
                    id={option.id}
                    role='option'
                    aria-selected={this.state.selectedOption === index}
                    tabIndex={0}
                    key={index}
                    onKeyDown={(event) => {
                      this.handleKeyDown(event, index, option)
                    }}
                    onClick={() => {
                      this.onclickOptionSelected(index, option)
                    }}>
                    <p>{option.modelo}</p>
                  </li>
                ))
            }
          </ul>
        </div>
      </div>
    )
  }
}

export default DropDown
